import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

function GameJoin() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await fetch(`${API_URL}/api/game/${gameId}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username }),
      });

      if (response.status === 201) {
        const userData = await response.json();
        // Use server-provided user ID
        localStorage.setItem('userId', userData.id);
        localStorage.setItem('username', username);
        
        // Redirect to game view
        navigate(`/game/${gameId}`);
      } else if (response.status === 409) {
        setError('This username is already taken in this game');
      } else if (response.status === 404) {
        setError('Game not found');
      } else {
        setError('Failed to join the game');
      }
    } catch (err) {
      setError('Failed to connect to the server');
    }
  };

  return (
    <div className="game-join">
      <h2>Join Game</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Choose your username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            placeholder="Enter username"
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit">Join Game</button>
      </form>
    </div>
  );
}

export default GameJoin; 